function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#f2c41b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M68.085.882a2.014 2.014 0 00-3.334 0L54.687 15.679H78.15zM54.687 76.607l10.065 14.797a2.014 2.014 0 003.334 0L78.15 76.607zM35.593 12.96a2.013 2.013 0 00-2.357 2.357l3.346 17.58 16.591-16.591zM99.601 76.968l-3.346-17.58-16.591 16.591 17.58 3.346a2.013 2.013 0 002.357-2.357z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.158 44.476a2.014 2.014 0 000 3.334l14.797 10.065V34.411zM111.679 44.476L96.882 34.411v23.463l14.797-10.065a2.014 2.014 0 000-3.333z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M36.582 59.388l-3.346 17.58a2.016 2.016 0 002.357 2.358l17.58-3.346zM99.046 13.515a2.015 2.015 0 00-1.802-.555l-17.58 3.346 16.591 16.591 3.346-17.58a2.015 2.015 0 00-.555-1.802z"
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 66.418,
  cy: 46.143,
  fill: "#ffda52",
  transform: "rotate(-87.82 66.416 46.16)",
  r: 33.003
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M314.509 48.856h-86.323a6 6 0 010-12h86.323c6.853 0 12.428-5.575 12.428-12.428S321.362 12 314.509 12H296.75a6 6 0 010-12h17.759c13.47 0 24.428 10.958 24.428 24.428s-10.958 24.428-24.428 24.428zM469.635 186.65h-14.764a6 6 0 010-12h14.764c5.14 0 9.32-4.181 9.32-9.32s-4.181-9.32-9.32-9.32H397.87a6 6 0 010-12h71.765c11.756 0 21.32 9.564 21.32 21.32s-9.564 21.32-21.32 21.32zM324.366 70.422h-80.062a6 6 0 010-12h80.062a6 6 0 010 12zM482.313 130.341h-30.356a6 6 0 010-12h30.356a6 6 0 010 12z",
  fill: "#b4d7dc"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M71.207 253.248v76.465c0 9.396 7.618 17.014 17.014 17.014s17.014-7.617 17.014-17.014v-76.465l-15.079-8.253zM176.33 164.58h-36.952l-.154.588c-3.163 12.071 5.944 23.872 18.423 23.872h.425c12.732 0 21.879-12.253 18.258-24.46z",
  fill: "#ffb69e"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M133.004 511.231c-11.276 0-20.417-9.141-20.417-20.417V327.62c0-11.276 9.141-20.417 20.417-20.417s20.417 9.141 20.417 20.417v163.194c0 11.276-9.141 20.417-20.417 20.417z",
  fill: "#5f6e9b"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 157.835,
  cy: 118.069,
  fill: "#ffb69e",
  transform: "rotate(-67.48 157.88 118.03)",
  r: 35.262
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M182.659 511.231c-11.276 0-20.417-9.141-20.417-20.417V327.62c0-11.276 9.141-20.417 20.417-20.417s20.417 9.141 20.417 20.417v163.194c0 11.276-9.141 20.417-20.417 20.417z",
  fill: "#414b82"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M247.362 244.493l-2.966-19.718v-20.058-.085c-.11-22.09-18.454-40.061-40.891-40.061H176.33l.001.009c.447 9.978-8.812 18.476-18.476 18.476-10.358 0-18.028-8.466-18.476-18.476v-.009h-27.213c-22.473 0-40.847 17.971-40.957 40.061v48.616h34.028v-48.475c.036-3.236 3.33-6.174 6.929-6.174h.423V327.62h90.489l-.158-129.022h.587c3.565 0 6.827 2.939 6.863 6.174v39.72h36.992z",
  fill: "#64afff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M292.366 216.175c-4.783-8.089-15.216-10.768-23.305-5.986l-24.665 14.585-21.587 16.008c0-.003-12.441 0-12.441 0v13.819c0 13.228 14.406 21.308 25.674 14.645l50.339-29.767c8.088-4.782 10.768-15.216 5.985-23.304z",
  fill: "#ffb69e"
});

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M235.869 273.327a6 6 0 01-3.031-11.184c37.482-21.875 62.676-67.609 82.377-109.461 23.99-50.965 74.697-72.99 76.844-73.902a6 6 0 014.7 11.042c-.484.207-48.693 21.249-70.687 67.971-13.527 28.736-25.634 50.222-38.102 67.617-15.299 21.345-31.354 36.751-49.084 47.099a5.97 5.97 0 01-3.017.818z",
  fill: "#55879b"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M457.201 0h-71.493a6.978 6.978 0 00-6.789 5.36l-22.407 93.9c-1.208 5.061 3.348 9.617 8.41 8.409l93.9-22.406a6.98 6.98 0 005.36-6.789V6.98A6.981 6.981 0 00457.201 0z",
  fill: "#e64937"
});

var SvgPeople = function SvgPeople(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 511.231 511.231",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPeople, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/people.eb178871.svg";
export { ForwardRef as ReactComponent };